import SelectedSpecs from './SelectedSpecs';

export default class VariantStore {
    static variants = [];

    static set(variants) {
        this.variants = variants;
    }

    static get(index) {
        return this.variants[index];
    }

    static getFirst() {
        return this.variants[0];
    }

    static getAll() {
        return this.variants;
    }

    static getClosestExistingVariant(selectedSpec, selectedSpecs) {
        const clonedSpecs = selectedSpecs.clone();
        // perfect match
        let closestVariant = VariantStore.getVariantBySpecCombination(selectedSpecs.toString());
        if (!closestVariant) {
            // define spec hierarchy in loop order, add selectedSpec at the start to give it the highest priority
            const specOrder = new Set([selectedSpec]);
            // this order is defined in the concept
            specOrder.add('FARB');
            specOrder.add('RHOE');
            specOrder.add('AKLW');

            // add all NOT predefined specs after the definition above for a lower priority
            Object.keys(clonedSpecs.values).forEach(selectedSpec => {
                specOrder.add(selectedSpec);
            });

            // reverse specOrder and delete the least important specs at first
            Array.from(specOrder)
                .reverse()
                .forEach(currentSpec => {
                    if (currentSpec !== selectedSpec && clonedSpecs.get(selectedSpec) && !closestVariant) {
                        // delete one spec after another in hierarchy oder to find the variant with the biggest overlap
                        clonedSpecs.delete(currentSpec);
                        closestVariant = VariantStore.getVariantBySpecCombinationPart(clonedSpecs.toString());
                    }
                });
        }
        // actually impossible but keep getFirst as the ultimate fallback
        const variant = closestVariant ?? VariantStore.getFirst();
        return {
            variant,
            specs: new SelectedSpecs(variant.specCombinationKey),
        };
    }

    static getFirstAvailableProductVariantAndSpecsInColor(color, selectedSpecs) {
        const specs = selectedSpecs.clone();
        specs.set('FARB', color);
        const nextVariant = VariantStore.getVariantBySpecCombination(specs.toString());

        const variant =
            nextVariant ??
            this.variants.find(variant => {
                return variant.specs?.FARB?.attributeKey === color;
            });

        return {
            variant,
            specs: new SelectedSpecs(variant.specCombinationKey),
        };
    }

    static getVariantBySpecCombination(specCombinationKey) {
        return this.variants.find(variant => variant.specCombinationKey === specCombinationKey);
    }

    static getVariantBySpecCombinationPart(specCombinationKeyPart) {
        return this.variants.find(variant => {
            const variantKeyParts = variant.specCombinationKey.split('-');
            const searchKeyParts = specCombinationKeyPart.split('-');
            return searchKeyParts.every(searchPart => variantKeyParts.includes(searchPart));
        });
    }
}
